/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Address_CepInputs */

const en_clients_field_address_cep = /** @type {(inputs: Clients_Field_Address_CepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CEP`)
};

const pt_br2_clients_field_address_cep = /** @type {(inputs: Clients_Field_Address_CepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CEP`)
};

/**
* | output |
* | --- |
* | "CEP" |
*
* @param {Clients_Field_Address_CepInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_address_cep = /** @type {((inputs?: Clients_Field_Address_CepInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Address_CepInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_address_cep(inputs)
	return pt_br2_clients_field_address_cep(inputs)
});